import PropTypes from 'prop-types'
import React from 'react'
import { otherFormAdditionalConfigOptions } from '../../../configs/officeHourConfig'
import AdditionalConfig from './AdditionalConfig'

const OtherFormAdditionalConfig = ({ enabled }) => {
  return (
    <AdditionalConfig
      name="other_forms_additional_config"
      label="Configuración adicional"
      hint="El horario de atención definido:"
      optionsSource={otherFormAdditionalConfigOptions}
      enabled={enabled}
    />
  )
}

export default OtherFormAdditionalConfig

OtherFormAdditionalConfig.propTypes = {
  enabled: PropTypes.bool
}
